var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { WorkspaceLoginConfigKeyFactory } from '../../query-key-factories';
export const getWorkspaceLoginConfigByNameQueryFactory = (lucidSdk, workspaceName) => ({
    queryKey: WorkspaceLoginConfigKeyFactory.byName(workspaceName),
    queryFn: () => lucidSdk.publicClient().getWorkspaceLoginConfigByName(workspaceName),
});
export const useGetWorkspaceLoginConfigByName = (workspaceName, { enabled = true } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const query = useQuery({
        ...getWorkspaceLoginConfigByNameQueryFactory(lucidSdk, workspaceName),
        enabled: Boolean(workspaceName) && enabled,
    });
    return query;
};
_react_refresh_temp_1(useGetWorkspaceLoginConfigByName, "H/nX1eMsJ0bsH20/D0j9QAs2SDk=", false, () => [useLucidSdk, useQuery]);
